import {createRef, useEffect} from 'external/react'
import {
  Box
  ,styleAndCapture
} from 'external/material'
import { mixStyle } from 'utils/style'

//import useOpenfire from 'hooks/openfire'
import useSession from 'hooks/session'
import useDimension from 'hooks/dimensions'
import useProfile from 'hooks/profile'

const StyledChat = styleAndCapture(Box, 'windowHeight', 'pageName')(chatStyles)

export default function Chat (props) {
  const {languageId, pageName} = useSession()
  const htmlRef = createRef()
  const {width, height} = useDimension(htmlRef) 

  useEffect(() => {
    if (htmlRef.current) {
      window.chatContainer = htmlRef.current
      window.onChatContainer && window.onChatContainer(htmlRef.current, pageName)
    }
  }, [pageName, htmlRef, width, height])

  return (
    <StyledChat pageName={pageName} windowHeight={props.windowHeight} ref={htmlRef} id="conversejsContainer">
    </StyledChat>
  )
}

function chatStyles ({pageName, windowHeight, theme}) {

  /*
  const verticalOffset = mixStyle(theme.mixins.toolbar, ['minHeight'], offset => {
    const height = windowHeight - (offset * 2)
    return {
      marginTop: offset * 2,
      height: `${height}px`,
      maxHeight: `${height}px`,
    }
  })
  */

  return {
    display: pageName == 'chat' ? 'flex': 'none',
    flexGrow: 1,
    
  }
}
